import React, { useEffect, useState } from 'react';
import useToken from './useToken';
import axios from 'axios';
import { Navigate, Outlet } from 'react-router-dom';

function SocialGlassGuard({ children }) {
  const { token } = useToken();
  const [hasPermission, setHasPermission] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!token) {
      setHasPermission(false);
      setLoading(false);
      return;
    }

    const checkPermission = async () => {
      try {
        const response = await axios.get('https://genz-staging.feeltiptop.com/api/social_glass/SocialGlassGuard', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setHasPermission(response.data.success);
      } catch (err) {
        setHasPermission(false);
      } finally {
        setLoading(false);
      }
    };

    checkPermission();
  }, [token]);

  if (loading) return <div>Loading...</div>;
  if (!hasPermission) return <Navigate to="/login" replace />;

  return children; 
} 

export default SocialGlassGuard;
